import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Application } from '@classes/application/application';
import { AppUser, InfosUser } from '@classes/auth/infosUser';
import { NavLinks } from '@classes/navlinks/navlinks';
import { environment } from '@environments/environment';
import { faCar, faCog, faGlobeEurope, faSitemap } from '@fortawesome/free-solid-svg-icons';
import { ApplicationService } from '@services/application/application.service';
import { AuthService } from '@services/auth/auth.service';
import { DataService } from '@services/data/data.service';

@Component({
  selector: 'app-choose-appli',
  templateUrl: './choose-appli.component.html',
  styleUrls: ['./choose-appli.component.scss']
})
export class ChooseAppliComponent implements OnInit {

  faGlobeEurope = faGlobeEurope;
  faCar = faCar;
  faCog = faCog;
  faSiteMap = faSitemap;
  applications: Application[];
  userConnected: InfosUser;
  appUserConnected: AppUser[];

  constructor(
    private authSrv: AuthService,
    private applicationService: ApplicationService,
    private router: Router,
    private dataService: DataService

  ) { }

  ngOnInit() {
    this.dataService.appName.next(environment.appName);
    this.dataService.logoApp.next(faSitemap);

    this.userConnected = this.authSrv.getDecodedToken();
    this.appUserConnected = this.userConnected.application as AppUser[];
    this.getApplications();
  }

  getIcon(icon: string): object {
    let faicon: object;

    switch (icon) {
      case 'faCar':
        faicon = this.faCar;
        break;
      case 'faGlobeEurope':
        faicon = this.faGlobeEurope;
        break;
      case 'faCog':
        faicon = this.faCog;
        break;

      default:
        break;
    }

    return faicon;
  }

  goToApplication({ url }): void {

    if (url === '/admin') {
      this.router.navigate(['/admin']);
    } else {
      const navigateTo = this.router.serializeUrl(
        this.router.createUrlTree([`${url}`])
      );

      window.open(navigateTo, '_blank');

    }

  }

  appAuthorized({ appName }): boolean {
    const indexApp = this.appUserConnected.findIndex(app => app.applicationName.toLowerCase() === appName.toLowerCase());

    return indexApp !== -1 ? true : false;
  }

  haveAdmin({ appName }): boolean {
    const indexApp = this.appUserConnected.findIndex(app => app.applicationName.toLowerCase() === appName.toLowerCase());
    return (indexApp !== -1 && appName === 'Administration') ? false : true;
  }

  private getApplications(): void {
    this.applications = this.applicationService.applications;
  }

}
